import React, { useEffect, useRef } from 'react';
import type { WorkspaceNotice } from '../notices';
import { Icon } from './icons';

interface Props {
  notice: WorkspaceNotice | null;
  onClose: () => void;
}

export const Notice: React.FC<Props> = ({ notice, onClose }) => {
  const root = useRef<HTMLDivElement>(null);

  // Сообщение рисуется вверху страницы, а кнопка, после которой оно появилось, может быть далеко внизу
  // (длинный список, липкая корзина, телефон): плашка сама прокручивает страницу к себе.
  // Ключ — сам объект сообщения: новый объект прокручивает снова, повторная отрисовка того же — нет.
  useEffect(() => {
    const node = root.current;
    if (node && typeof node.scrollIntoView === 'function') { // в jsdom и старых браузерах функции нет
      node.scrollIntoView({ block: 'nearest' });
    }
  }, [notice]);

  if (!notice) return null; // после хуков: порядок хуков не меняется
  return (
    <div ref={root} className={`tw-notice ${notice.kind === 'ok' ? 'tw-notice-ok' : 'tw-notice-info'}`} role="status">
      <Icon name={notice.kind === 'ok' ? 'check' : 'info'} />
      <span className="tw-notice-text">{notice.text}</span>
      <button type="button" className="tw-btn tw-btn-small tw-btn-quiet" onClick={onClose}>
        Закрыть
      </button>
    </div>
  );
};
